import { Button, type ButtonProps } from "~/components/button";
import { cn } from "~/utils";

export const KeywordFeedbackPill = ({
  children,
  className,
  ...rest
}: Omit<ButtonProps, "type" | "variant" | "size" | "asChild">) => (
  <Button
    type="button"
    variant="tertiary"
    size="small"
    className={cn(
      "h-auto px-2.5 py-1.5 text-xs font-normal rounded-full cursor-pointer",
      "border-secondary-200 bg-white text-secondary-600",
      "hover:border-primary-500 hover:bg-primary-25 hover:text-primary-600",
      className,
    )}
    {...rest}
  >
    {children}
  </Button>
);
